// Mirrors IntegrationConstants.ShippingLabelStatus in the Auth service; null means no label has been uploaded.
export const ShippingLabelStatus = {
    WaitingReview: 'Waiting Review',
    Rejected: 'Rejected',
    Complete: 'Complete'
};

export const SHIPPING_LABEL_TASK_TITLE = 'Upload shipping label for approval';
